module.exports = __webpack_public_path__ + "static/media/certificate_ascendo_sign.2a058021.png";